import type { PropsWithChildren } from "react";
import { cn } from "@/lib/style/cva.config";

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;
type HeadingClassName = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLHeadingElement>,
  HTMLHeadingElement
>["className"];

type Props = {
  order: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
} & PropsWithChildren;

const DEFAULT: Record<HeadingLevel, HeadingClassName> = {
  1: "text-xl font-semibold mb-4",
  2: "text-lg font-semibold mb-2",
  3: "",
  4: "",
  5: "",
  6: "",
};

export function Heading({ order, children, className }: Props) {
  const styleClass = cn(DEFAULT[order], className);
  switch (order) {
    case 1:
      return <h1 className={styleClass}>{children}</h1>;
    case 2:
      return <h2 className={styleClass}>{children}</h2>;
    case 3:
      return <h3 className={styleClass}>{children}</h3>;
    case 4:
      return <h4 className={styleClass}>{children}</h4>;
    case 5:
      return <h5 className={styleClass}>{children}</h5>;
    case 6:
      return <h6 className={styleClass}>{children}</h6>;
    default:
      return <h1 className={styleClass}>{children}</h1>;
  }
}
